import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getClient, showReportDialog, withScope, captureException } from '@sentry/browser';
import { isError, logger } from '@sentry/utils';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';
import { DEBUG_BUILD } from './debug-build.js';
var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function isAtLeastReact17(version) {
  var major = version.match(/^([^.]+)/);
  return major !== null && parseInt(major[0]) >= 17;
}
var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null
};
function setCause(error, cause) {
  var seenErrors = new WeakMap();
  function recurse(error, cause) {
    // If we've already seen the error, there is a recursive loop somewhere in the error's
    // cause chain. Let's just bail out then to prevent a stack overflow.
    if (seenErrors.has(error)) {
      return;
    }
    if (error.cause) {
      seenErrors.set(error, true);
      return recurse(error.cause, cause);
    }
    error.cause = cause;
  }
  recurse(error, cause);
}

/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    ErrorBoundary.prototype.__init.call(_this);
    _this.state = INITIAL_STATE;
    _this._openFallbackReportDialog = true;
    var client = getClient();
    if (client && client.on && props.showDialog) {
      _this._openFallbackReportDialog = false;
      client.on('afterSendEvent', function (event) {
        if (!event.type && event.event_id === _this._lastEventId) {
          // eslint-disable-next-line deprecation/deprecation
          showReportDialog(_objectSpread(_objectSpread({}, props.dialogOptions), {}, {
            eventId: _this._lastEventId
          }));
        }
      });
    }
    return _this;
  }
  _inherits(ErrorBoundary, _React$Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, _ref) {
      var _this2 = this;
      var componentStack = _ref.componentStack;
      var _this$props = this.props,
        beforeCapture = _this$props.beforeCapture,
        onError = _this$props.onError,
        showDialog = _this$props.showDialog,
        dialogOptions = _this$props.dialogOptions;
      withScope(function (scope) {
        // If on React version >= 17, create stack trace from componentStack param and links
        // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
        // Linking errors requires the `LinkedErrors` integration be enabled.
        // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
        //
        // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
        // with non-error objects. This is why we need to check if the error is an error-like object.
        // See: https://github.com/getsentry/sentry-javascript/issues/6167
        if (isAtLeastReact17(React.version) && isError(error)) {
          var errorBoundaryError = new Error(error.message);
          errorBoundaryError.name = "React ErrorBoundary ".concat(error.name);
          errorBoundaryError.stack = componentStack;

          // Using the `LinkedErrors` integration to link the errors together.
          setCause(error, errorBoundaryError);
        }
        if (beforeCapture) {
          beforeCapture(scope, error, componentStack);
        }
        var eventId = captureException(error, {
          captureContext: {
            contexts: {
              react: {
                componentStack: componentStack
              }
            }
          },
          // If users provide a fallback component we can assume they are handling the error.
          // Therefore, we set the mechanism depending on the presence of the fallback prop.
          mechanism: {
            handled: !!_this2.props.fallback
          }
        });
        if (onError) {
          onError(error, componentStack, eventId);
        }
        if (showDialog) {
          _this2._lastEventId = eventId;
          if (_this2._openFallbackReportDialog) {
            showReportDialog(_objectSpread(_objectSpread({}, dialogOptions), {}, {
              eventId: eventId
            }));
          }
        }

        // componentDidCatch is used over getDerivedStateFromError
        // so that componentStack is accessible through state.
        _this2.setState({
          error: error,
          componentStack: componentStack,
          eventId: eventId
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;
      if (onMount) {
        onMount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state = this.state,
        error = _this$state.error,
        componentStack = _this$state.componentStack,
        eventId = _this$state.eventId;
      var onUnmount = this.props.onUnmount;
      if (onUnmount) {
        onUnmount(error, componentStack, eventId);
      }
    }
  }, {
    key: "__init",
    value: function __init() {
      var _this3 = this;
      this.resetErrorBoundary = function () {
        var onReset = _this3.props.onReset;
        var _this3$state = _this3.state,
          error = _this3$state.error,
          componentStack = _this3$state.componentStack,
          eventId = _this3$state.eventId;
        if (onReset) {
          onReset(error, componentStack, eventId);
        }
        _this3.setState(INITIAL_STATE);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        fallback = _this$props2.fallback,
        children = _this$props2.children;
      var state = this.state;
      if (state.error) {
        var element = undefined;
        if (typeof fallback === 'function') {
          element = fallback({
            error: state.error,
            componentStack: state.componentStack,
            resetError: this.resetErrorBoundary,
            eventId: state.eventId
          });
        } else {
          element = fallback;
        }
        if (React.isValidElement(element)) {
          return element;
        }
        if (fallback) {
          DEBUG_BUILD && logger.warn('fallback did not produce a valid ReactElement');
        }

        // Fail gracefully if no fallback provided or is not valid
        return null;
      }
      if (typeof children === 'function') {
        return children();
      }
      return children;
    }
  }]);
}(React.Component); // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
  var _this4 = this;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
  var Wrapped = function Wrapped(props) {
    return React.createElement(ErrorBoundary, _objectSpread(_objectSpread({}, errorBoundaryOptions), {}, {
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 240
      }
    }), React.createElement(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      __self: _this4,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 241
      }
    })));
  };

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  Wrapped.displayName = "errorBoundary(".concat(componentDisplayName, ")");

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}
export { ErrorBoundary, UNKNOWN_COMPONENT, isAtLeastReact17, withErrorBoundary };